import { render } from "./filters.vue?vue&type=template&id=54c3fb70&bindings={\"filters\":\"props\",\"filtersAvailable\":\"props\",\"isFilterAvailable\":\"options\"}"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"

import "./filters.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script